import styled from 'styled-components';
import { NavBarHeight } from 'const';

export const PageContainer = styled.div`
  min-height: calc(100vh - ${NavBarHeight}px);
  width: 100%;
  color: ${props => props.theme.colors.greenDark};
  background-color: ${props => props.theme.colors.white};
`;
